import {
    MenuItem,
    //    Select
} from '@mui/material'
import { Select, SelectSection, SelectItem } from '@nextui-org/react'

const RangeDropDown = (props, chartRange, onChange) => {
    const dropDownChartRange = props['chartRange'] || chartRange
    const dropDownOnChange = props['onChange'] || onChange

    const chartDropDownOptions = Object.keys(props).includes(
        'chartDropDownOptions',
    )
        ? props['chartDropDownOptions']
        : [
              { value: 1, label: '24 Hours' },
              { value: 2, label: '48 Hours' },
              { value: 3, label: '72 Hours' },
              { value: 7, label: '7 Days' },
              { value: 15, label: '15 Days' },
              { value: 30, label: '30 Days' },
              { value: 60, label: '60 Days' },
              { value: 90, label: '90 Days' },
              { value: 180, label: '180 Days' },
              { value: 365, label: '365 Days' },
              { value: 0, label: 'All Time' },
          ]

    return (
        <Select
            size="md"
            fullWidth
            placeholder="Select Range"
            onChange={dropDownOnChange}
            value={dropDownChartRange}
            variant="faded"
        >
            {chartDropDownOptions.map((option, idx) => (
                <SelectItem value={option.value} key={option.value}>
                    {option.label}
                </SelectItem>
            ))}
        </Select>
    )
}

export default RangeDropDown
